import { INITIAL_SPECIES_REQUEST, FETCH_SPECIES_SUCCESS, FINAL_SPECIES_REQUEST } from "../../types/maintainers/species.type";

const initialState = {
	estates: [],
	customers: [],
	species: [],
	categories: [],
	last_page: 0,
	from: 0,
	to: 0,
	isFetching: false,
};

function maintainers_species(state = initialState, action) {
	switch (action.type) {
		case INITIAL_SPECIES_REQUEST:
			return {
				...state,
				isFetching: true,
			};
		case FETCH_SPECIES_SUCCESS:
			return {
				...state,
				isFetching: false,
				customers: action.payload.customers,
				estates: action.payload.estates,
				species: action.payload.species,
				categories: action.payload.categories,
				last_page: action.payload.last_page,
				from: action.payload.from,
				to: action.payload.to,
				quantity: action.payload.quantity,
			};
		case FINAL_SPECIES_REQUEST:
			return {
				...state,
				isFetching: false,
			};
		default:
			return state;
	}
}

export default maintainers_species;
